import { ReactElement } from 'react';
import { renderToStaticMarkup } from "react-dom/server";

import { ReactComponent as PinletInactiveIcon } from 'assets/Markers/pinlet-marker-inactive.svg';
import { ReactComponent as PinletActiveIcon } from 'assets/Markers/pinlet-marker-active.svg';

import leaflet, { BaseIconOptions, DivIconOptions } from "leaflet";

type Props = {
  color?: string;
}
const iconConfig: BaseIconOptions = {
  iconSize: [35, 35],
  iconAnchor: [16, 37]
};

const formatDivIcon = (svg: ReactElement): DivIconOptions => {
  return {
    html: renderToStaticMarkup(svg),
    ...iconConfig,
  };
};

export function foundMarker() {
  return new leaflet.DivIcon(
    formatDivIcon(
      <div className="lastLocationMarker">
        <PinletActiveIcon />
      </div>
    )
  )
}

export function lastLocationMarker() {
  return new leaflet.DivIcon(
    formatDivIcon(
      <div className="lastLocationMarker">
        <PinletInactiveIcon />
      </div>
    )
  )
}